import React from "react";

const Newsstaller = () => {
  return (
    <section className="sepration-section">
      <div className="sepration-diev">
        <h1 className="download-app text-4xl font-semibold">
        Conversation with Strangers in real life
        </h1>
      </div>
    </section>
  );
};

export default Newsstaller;
